import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ExternalChannelInfoPopup = loadAsyncComponent(() => import('./View'), 'popup');
